import {
  ContentTypeEnum as ContentTypeDto,
  type Media as MediaDto,
} from "@rarible/marketplace-backend-v6-client/build"
import { z } from "zod"
import { DropPreviewType } from "../drop/types"
import type { Media, NftId } from "./types"

export function toNftId(value: string) {
  return value as NftId
}

export const NFT_ID_VALIDATION = z
  .string()
  .refine((value) => {
    try {
      toNftId(value)

      return true
    } catch (e) {
      return false
    }
  })
  .transform((value) => toNftId(value))

export function mediaFromDto(dto: MediaDto): Media | null {
  const type = contentTypeFromDto(dto.contentType)
  if (!type) return null
  return { type, url: dto.url }
}

export function contentTypeFromDto(dto: ContentTypeDto) {
  switch (dto) {
    case ContentTypeDto.IMAGE:
      return DropPreviewType.Image
    case ContentTypeDto.VIDEO:
      return DropPreviewType.Video
    case ContentTypeDto.THREE_D:
      return DropPreviewType.ThreeD
    default:
      return null
  }
}
